import React from "react";

/** A wizard step's title and line. The same markup as MatchSchedulingStep's header, so one style covers every step. */
const StepHeader = ({ title, subtitle, children }: { title: React.ReactNode; subtitle?: React.ReactNode; children?: React.ReactNode }) => (
  <div className="header">
    <p className="title">{title}</p>
    {subtitle ? <p className="subtitle">{subtitle}</p> : null}
    {children}
  </div>
);

export default StepHeader;
